export default {
  goal: 'Accéder au parcours de conseil transmission',
  title: 'Votre transmission',
  label: 'Votre transmission',
}
